import styled from '@emotion/styled'

import media from '../../styles/media'
import { colors, fonts } from '../../styles/theme'

const S = {}

S.AccordionSubheader = styled.div`
  --transition: 0.2s ease-in-out;

  position: fixed;
  width: 100%;
  top: 3.75rem;
  left: 0;
  right: 0;
  height: ${({ isOpen }) => (isOpen ? 'calc(100% - 3.75rem)' : '4rem')};
  z-index: 1020;
  font-family: ${fonts.menu};
  user-select: none;
  overflow: ${({ isOpen }) => isOpen && 'auto'};

  ${media.lg`
    height: 4rem;
    background-color: ${colors.black};
  `};

  ::-webkit-scrollbar {
    width: 0.75rem;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${colors.scarpaFlow};
    border: 0.1875rem solid ${colors.shark};

    &:active {
      background-color: ${colors.silverChalice};
      border: 0.125rem solid ${colors.shark};
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.silverChalice};
        border: 0.125rem solid ${colors.shark};
      }
    }
  }

  ::-webkit-scrollbar-track {
    background-color: ${colors.shark};
  }

  .default {
    display: ${({ isOpen }) => (isOpen ? 'none' : 'flex')};
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    color: ${colors.white};
    font-size: 0.875rem;
    font-weight: 800;
    text-transform: uppercase;
    cursor: pointer;
    line-height: 1.125rem;
    box-sizing: border-box;
    padding-inline-start: 1.25rem;
    background-color: ${colors.black};
    transition: var(--transition);
    transition-property: background-color;

    ${media.md`
      padding-inline-start: 2.5rem;
    `};

    ${media.lg`
      display: none;
      line-height: 1.25rem;
    `};

    &:focus {
      background-color: ${colors.woodsmoke};
      outline: 0.125rem solid transparent;
      outline-offset: 0.125rem;
      box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.woodsmoke};
      }
    }
  }

  .svg-icon {
    fill: currentColor;
    line-height: 0;
    padding-inline: 1.25rem;

    ${media.md`
      padding-inline: 2.5rem;
    `};

    &-subnav,
    &-list {
      position: absolute;
      cursor: pointer;
      inset-block-start: 0.75rem;
      inset-inline-end: 0;
    }

    &-list {
      ${media.lg`
        display: none;
      `};
    }
  }

  .icon-triangle {
    path {
      color: ${colors.white};
    }

    &-list {
      transform: rotate(180deg);

      &:focus {
        outline: 0.125rem solid transparent;
        outline-offset: 0.125rem;
        box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;
      }
    }
  }

  .accordion {
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    background-color: ${colors.shark};

    ${media.lg`
      display: flex;
      height: 100%;
      background: transparent;
    `};
  }

  .ul-main {
    margin: 0;
    padding: 0;
    list-style-type: none;

    ${media.lg`
      display: flex;
      justify-content: center;
      flex: 1 0 auto;
    `}
  }

  .accordion-item-subnav {
    position: relative;
  }
`

S.AccordionItem = styled.li`
  transition: var(--transition);
  transition-property: background-color;

  @media (hover: hover) {
    &:hover {
      background-color: ${colors.woodsmoke};

      ${media.lg`
        background-color: transparent;
      `};
    }
  }

  &.has-sub {
    position: relative;
    cursor: pointer;
    background-color: ${({ isOpen }) => isOpen && colors.woodsmoke};

    span {
      ${media.md`
        padding-inline-end: 4.375rem;
      `};
    }
  }

  .svg-icon {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }

  &.has-sub,
  .accordion-link {
    display: flex;
    align-items: center;
    font-weight: 800;
    font-size: 0.875rem;
    text-transform: uppercase;
    width: 100%;
    height: 100%;
    padding-inline-start: 1.25rem;
    padding-inline-end: 4.375rem;
    color: ${({ isOpen }) => (isOpen ? colors.white : colors.silver)};
    box-sizing: border-box;
    min-height: 4rem;
    text-decoration: none;
    transition: var(--transition);
    transition-property: color;

    ${media.md`
      padding-inline-start: 2.5rem;
      padding-inline-end: 6.25rem;
    `};

    ${media.lg`
      padding-inline-end: 2.5rem;
    `};

    &:focus {
      color: ${colors.white};
      background-color: ${colors.woodsmoke};
      outline: 0.125rem solid transparent;
      outline-offset: 0.125rem;
      box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;

      ${media.lg`
        background: transparent;
      `};
    }

    @media (hover: hover) {
      &:hover {
        color: ${colors.white};
      }
    }

    &.active {
      color: ${colors.orange};
      background-color: ${colors.woodsmoke};

      ${media.lg`
        background: transparent;
      `};
    }
  }
`

S.AccordionContent = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  ${media.lg`
    width: 100%;
    background-color: ${colors.woodsmoke};
  `};
`

export default S
